// Copyright 2022, Imprivata, Inc.  All rights reserved.
import { getConfig } from '@imprivata-cloud/common';
import { type PropsWithChildren, useMemo } from 'react';
import featureFlags from '../../featureFlags.json';
import { detectFeatureFlagEnv } from '../../utils/FeatureFlagEnvDetector';
import { useCodingContext } from './hooks';
import { type FeatureFlags, PlatformContext } from './PlatformContext';
export const PlatformProvider = ({ children }: PropsWithChildren) => {
  const env = import.meta.env;
  const config = useMemo(() => getConfig(env), []);
  const codingContextQuery = useCodingContext(config.METADATA_URL);
  const envFeatureFlags = useMemo<FeatureFlags>(() => {
    const tier = detectFeatureFlagEnv(window.location.host, env.MODE);
    return featureFlags[tier];
  }, []);
  return (codingContextQuery.isLoading || !codingContextQuery.data) ? null : (
    <PlatformContext.Provider value={{ codingContext: codingContextQuery.data, featureFlags: envFeatureFlags }}>
      {children}
    </PlatformContext.Provider>
  );
};
